import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Just to help explain a bit...`}</p>
    <h1>{`Nix & Home Manager`}</h1>
    <p>{`Why Nix? please visit my `}<a parentName="p" {...{
        "href": "../2020-10-24-nix-power"
      }}>{`previous post`}</a>{`. `}</p>
    <p>{`Home manager's default programs for darwin is limited and nix-darwin is intrusive for me. However, gpg's setup is not really hard nowaday (no more backend/daemon managing stuff). It's all about setting up `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gpg*.conf`}</code>{` files in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.gnupg`}</code>{` once you have `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gnupg`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pinentry`}</code>{` from nixpkgs.`}</p>
    <p>{`In home-manager, if you do:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}>{`programs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`gpg `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    enable `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`this will generate `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gpg.conf`}</code>{` file, while you do:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}>{`services`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`gpg`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span>{`agent `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    enable `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`It generates the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gpg-agent.conf`}</code>{`. But this services bundles with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`systemd`}</code>{` for Linux and it fails on Mac (on Mac `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`launchd`}</code>{` should be used). `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gpg-agent`}</code>{` will be started automatically when you make gpg calls so no need to manage it as service. Therefore, one workaround, which I'm showing now, is to directly grab the part we need in this `}<a parentName="p" {...{
        "href": "https://github.com/nix-community/home-manager/blob/master/modules/services/gpg-agent.nix"
      }}>{`service nix file`}</a>{`. `}</p>
    <p>{`So setup for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`curses`}</code>{` ends up like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  pinentryFlavor `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"curses"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
  home`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`file`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`".gnupg/gpg-agent.conf"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`text `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` lib`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`concatStringsSep `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"\\n"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"no-grab"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`++`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# more options`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`++`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"pinentry-program `}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pkgs`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`pinentry`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pinentryFlavor`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/bin/pinentry"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h1>{`Troubleshooting Guide`}</h1>
    <ul>
      <li parentName="ul">{`You might want to trash/rename `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.gnupg`}</code>{` folder for a fresh start.`}</li>
      <li parentName="ul">{`You might want to check if process `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`gpg-agent`}</code>{` is running.`}</li>
      <li parentName="ul">{`You might want to check keys with `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`gpg --list-secret-keys`}</code>{`.`}</li>
      <li parentName="ul">{`For neovim, `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`curses`}</code>{` would not work. You might want to use `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`pkgs.pinentry-mac`}</code>{` as pinentry or other alternatives such as gtk/qt for linux.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      